/**
 * Títulos e citação do texto rico, como o `RichTextEditor` os mostra. Fica fora do editor para
 * quem EXIBE o HTML publicado não importar o Tiptap e ver o texto como o autor o escreveu.
 * Parágrafo, ênfases e listas vêm do `.prose` do `globals.css`.
 */
export const TIPOGRAFIA_TEXTO_RICO = [
  '[&_h1]:mt-3',
  '[&_h1]:mb-2',
  '[&_h1]:text-[1.6em]',
  '[&_h1]:font-bold',
  '[&_h1]:leading-tight',
  '[&_h2]:mt-3',
  '[&_h2]:mb-2',
  '[&_h2]:text-[1.35em]',
  '[&_h2]:font-bold',
  '[&_h2]:leading-tight',
  '[&_h3]:mt-2',
  '[&_h3]:mb-1',
  '[&_h3]:text-[1.15em]',
  '[&_h3]:font-semibold',
  '[&_blockquote]:border-l-2',
  '[&_blockquote]:border-neutral-300',
  '[&_blockquote]:pl-4',
  '[&_blockquote]:italic',
  '[&_blockquote]:text-subtext-color',
].join(' ');
